'use strict';
import React, { Component, PropTypes } from 'react';
import { FormatMessage } from 'react-globalize';


class SectionBarri extends Component {

  componentDidMount() {
    this.props.logPageView();
  }


  /**
   * @return {object}
   */
  render() {
    return (
      <section id="section1" className="content-section text-center about-section sectionPage">
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-12 col-xs-offset-1">
            <div className="title-v1">
              <div className="row">
                <div className="col-md-12 col-sm-10 col-xs-10">
                  <h1><FormatMessage locale={this.props.locale} path="menu/menuBarri" /></h1>
                  <hr className="small" />
                  <p className="text-uppercase text-left"><strong><FormatMessage
                    locale={this.props.locale} path="barriPage/ourHistory" /></strong></p>
                  <p className="text-justify"><FormatMessage locale={this.props.locale}
                    path="barriPage/paragraph1" />
                    <br /><br /><FormatMessage locale={this.props.locale}
                      path="barriPage/paragraph2" /> <br /><br />
                    <FormatMessage locale={this.props.locale} path="barriPage/paragraph3" /></p><br />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-xs-10">
                <div className="title-v1 service-block text-justify"><h3><FormatMessage
                  locale={this.props.locale} path="barriPage/ourPurpose" /></h3>
                  <hr className="small" />
                  <FormatMessage locale={this.props.locale} path="barriPage/ourPurposeParagraph" />
                </div>
              </div>

              <div className="col-md-6 col-xs-10">
                <div className="title-v1 service-block"><h3><FormatMessage locale={this.props.locale}
                  path="barriPage/ourValues" />
                </h3>
                  <hr className="small" />
                  <ul className="list-unstyled lists-v2">
                    <li><i className="fa fa-circle-o"></i>&nbsp;<strong><FormatMessage
                      locale={this.props.locale} path="barriPage/ourValuesIntegrity" /></strong>
                      &nbsp;<FormatMessage locale={this.props.locale} path="barriPage/integrityDescription" />
                    </li>
                    <li><i className="fa fa-circle-o"></i>&nbsp;<strong><FormatMessage
                      locale={this.props.locale} path="barriPage/ourValuesFamily" /></strong>&nbsp;
                      <FormatMessage locale={this.props.locale} path="barriPage/familyDescription" />
                    </li>
                    <li><i className="fa fa-circle-o"></i>&nbsp;<strong><FormatMessage
                      locale={this.props.locale} path="barriPage/ourValuesRespect" /></strong>&nbsp;
                      <FormatMessage locale={this.props.locale} path="barriPage/respectDescription" />
                    </li>
                    <li><i className="fa fa-circle-o"></i>&nbsp;<strong><FormatMessage
                      locale={this.props.locale} path="barriPage/ourValuesService" /></strong>&nbsp;
                      <FormatMessage locale={this.props.locale} path="barriPage/serviceDescription" />
                    </li>
                    <li><i className="fa fa-circle-o"></i>&nbsp;
                    <strong><FormatMessage locale={this.props.locale} path="barriPage/ourValuesAdvancement" />
                      </strong>&nbsp;
                      <FormatMessage locale={this.props.locale} path="barriPage/advancementDescription" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

}
;

module.exports = (SectionBarri);
//module.exports = SectionBarri



// WEBPACK FOOTER //
// ./js/sectionBarri.js